import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../helper/URLHelper';

import PolarisPageRouteView from './pages/PolarisPageRouteView.vue';
import AssistantsIndexPage from './pages/AssistantsIndexPage.vue';
import AssistantEmptyStateIndex from './assistants/Index.vue';

import AssistantOverviewIndex from './assistants/overview/Index.vue';
import AssistantGetStartedIndex from './assistants/getStarted/Index.vue';
import TemplatesIndex from './templates/Index.vue';
import AssistantVoiceDeployIndex from './assistants/voiceDeploy/Index.vue';
import AssistantSettingsIndex from './assistants/settings/Settings.vue';
import AssistantInboxesIndex from './assistants/inboxes/Index.vue';
import AssistantPlaygroundIndex from './assistants/playground/Index.vue';
import AssistantGuardrailsIndex from './assistants/guardrails/Index.vue';
import AssistantGuidelinesIndex from './assistants/guidelines/Index.vue';
import AssistantVoiceIndex from './assistants/voice/Index.vue';
import AssistantScenariosIndex from './assistants/scenarios/Index.vue';
import AssistantScenarioEdit from './assistants/scenarios/Edit.vue';
import DocumentsIndex from './documents/Index.vue';
import ResponsesIndex from './responses/Index.vue';
import ResponsesPendingIndex from './responses/Pending.vue';
import CustomToolsIndex from './tools/Index.vue';

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.POLARIS,
  installationTypes: [
    INSTALLATION_TYPES.CLOUD,
    INSTALLATION_TYPES.ENTERPRISE,
    INSTALLATION_TYPES.COMMUNITY,
  ],
};

const metaCustomTools = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.POLARIS_CUSTOM_TOOLS,
  installationTypes: [
    INSTALLATION_TYPES.CLOUD,
    INSTALLATION_TYPES.ENTERPRISE,
    INSTALLATION_TYPES.COMMUNITY,
  ],
};

const metaV2 = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.POLARIS_V2,
  installationTypes: [
    INSTALLATION_TYPES.CLOUD,
    INSTALLATION_TYPES.ENTERPRISE,
    INSTALLATION_TYPES.COMMUNITY,
  ],
};

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/polaris/:assistantId/get-started'),
    component: AssistantGetStartedIndex,
    name: 'polaris_assistants_get_started_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/polaris/:assistantId/voice'),
    component: AssistantVoiceDeployIndex,
    name: 'polaris_assistants_voice_deploy_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/polaris/:assistantId/overview'),
    component: AssistantOverviewIndex,
    name: 'polaris_assistants_overview_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/polaris/:assistantId/faqs'),
    component: ResponsesIndex,
    name: 'polaris_assistants_responses_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/polaris/:assistantId/documents'),
    component: DocumentsIndex,
    name: 'polaris_assistants_documents_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/polaris/:assistantId/tools'),
    component: CustomToolsIndex,
    name: 'polaris_tools_index',
    meta: metaCustomTools,
  },
  {
    path: frontendURL('accounts/:accountId/polaris/:assistantId/scenarios'),
    component: AssistantScenariosIndex,
    name: 'polaris_assistants_scenarios_index',
    meta: metaV2,
  },
  // Editor Fin-style em página cheia (Fase 4): o clique num cenário da tela Roteiro abre aqui.
  {
    path: frontendURL(
      'accounts/:accountId/polaris/:assistantId/scenarios/:scenarioId/edit'
    ),
    component: AssistantScenarioEdit,
    name: 'polaris_scenarios_edit',
    meta: {
      ...metaV2,
      trailParent: 'polaris_assistants_scenarios_index',
      trailLabel: 'POLARIS.ASSISTANTS.SCENARIOS.TITLE',
    },
  },
  {
    path: frontendURL('accounts/:accountId/polaris/:assistantId/playground'),
    component: AssistantPlaygroundIndex,
    name: 'polaris_assistants_playground_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/polaris/:assistantId/inboxes'),
    component: AssistantInboxesIndex,
    name: 'polaris_assistants_inboxes_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/polaris/:assistantId/faqs/pending'),
    component: ResponsesPendingIndex,
    name: 'polaris_assistants_responses_pending',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/polaris/:assistantId/settings'),
    component: AssistantSettingsIndex,
    name: 'polaris_assistants_settings_index',
    meta,
  },
  // Settings sub-pages (guardrails and guidelines). `trailParent`/`trailLabel`: the Topbar's breadcrumb shows
  // Settings as a link between the assistant and the page (useTopbarTrail), since the page has no "Back" (D-G2).
  {
    path: frontendURL(
      'accounts/:accountId/polaris/:assistantId/settings/guardrails'
    ),
    component: AssistantGuardrailsIndex,
    name: 'polaris_assistants_guardrails_index',
    meta: {
      ...metaV2,
      trailParent: 'polaris_assistants_settings_index',
      trailLabel: 'POLARIS.ASSISTANTS.GUARDRAILS.TITLE',
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/polaris/:assistantId/settings/guidelines'
    ),
    component: AssistantGuidelinesIndex,
    name: 'polaris_assistants_guidelines_index',
    meta: {
      ...metaV2,
      trailParent: 'polaris_assistants_settings_index',
      trailLabel: 'POLARIS.ASSISTANTS.RESPONSE_GUIDELINES.TITLE',
    },
  },
  // Voice (the voice prompt with its history): administrators only, behind the same flag as Settings — not behind
  // polaris_v2, so the page shows wherever the assistant's Settings show.
  {
    path: frontendURL(
      'accounts/:accountId/polaris/:assistantId/settings/voice'
    ),
    component: AssistantVoiceIndex,
    name: 'polaris_assistants_voice_index',
    meta: {
      ...meta,
      permissions: ['administrator'],
      trailParent: 'polaris_assistants_settings_index',
      trailLabel: 'POLARIS.ASSISTANTS.VOICE.TITLE',
    },
  },
  // Galeria de modelos (Fase 2): rota irmã das páginas de assistente, ANTES do catch-all `:navigationPath`.
  {
    path: frontendURL('accounts/:accountId/polaris/templates'),
    component: TemplatesIndex,
    name: 'polaris_templates_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/polaris/assistants'),
    component: AssistantEmptyStateIndex,
    name: 'polaris_assistants_create_index',
    meta: {
      trailLabel: 'POLARIS.ASSISTANTS.HEADER',
      permissions: ['administrator', 'agent'],
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
  },
  {
    path: frontendURL('accounts/:accountId/polaris/:navigationPath'),
    component: AssistantsIndexPage,
    name: 'polaris_assistants_index',
    meta,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/polaris'),
    component: PolarisPageRouteView,
    redirect: to => {
      return {
        name: 'polaris_assistants_index',
        params: {
          navigationPath: 'polaris_assistants_get_started_index',
          ...to.params,
        },
      };
    },
    children: [...assistantRoutes],
  },
];
